import React from 'react';
import Icon from '../../../components/AppIcon';

const FileMetadataPanel = ({ file, isExpanded, onToggle }) => {
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes?.[i];
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-muted transition-colors duration-150"
      >
        <div className="flex items-center gap-2">
          <Icon name="Info" size={18} className="text-primary" />
          <span className="text-sm font-semibold text-foreground">File Metadata</span>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={18} 
          className="text-muted-foreground"
        />
      </button>
      {isExpanded && (
        <div className="p-4 pt-0 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <p className="text-xs text-muted-foreground mb-1">File Name</p>
              <p className="text-sm font-medium text-foreground break-all">{file?.name}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">File Size</p>
              <p className="text-sm font-medium text-foreground font-mono">
                {formatFileSize(file?.size)}
              </p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">File Type</p>
              <p className="text-sm font-medium text-foreground">{file?.type}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Last Modified</p>
              <p className="text-sm font-medium text-foreground font-mono">
                {formatDate(file?.lastModified)}
              </p>
            </div>
          </div>

          {file?.s3Properties && (
            <div>
              <p className="text-xs text-muted-foreground mb-2 font-semibold">S3 Properties</p>
              <div className="bg-muted rounded-md p-3 space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-xs text-muted-foreground">Storage Class</span>
                  <span className="text-xs font-medium text-foreground font-mono">
                    {file?.s3Properties?.storageClass}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs text-muted-foreground">ETag</span>
                  <span className="text-xs font-medium text-foreground font-mono truncate max-w-[200px]">
                    {file?.s3Properties?.etag}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs text-muted-foreground">Encryption</span>
                  <span className="text-xs font-medium text-foreground font-mono">
                    {file?.s3Properties?.encryption}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs text-muted-foreground">ACL</span>
                  <span className="text-xs font-medium text-foreground font-mono">
                    {file?.s3Properties?.acl}
                  </span>
                </div>
              </div>
            </div>
          )}

          {file?.path && (
            <div>
              <p className="text-xs text-muted-foreground mb-1">S3 Path</p>
              <div className="bg-muted rounded-md p-2">
                <p className="text-xs font-medium text-foreground font-mono break-all">
                  {file?.path}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FileMetadataPanel;